import { IconButton, OdinIcon, OdinIconSize } from '@myosh/odin-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AnalysisJobResult } from '../../@types/background-jobs';
import RecordAnalysis from '../record/record-analysis.component';

interface SingleRecordAiAnalysisProps {
  isLoading: boolean;
  analysisResult: AnalysisJobResult | undefined;
  isAnalysisOutdated: boolean;
  isError: boolean;
  analysisTimestamp?: number;
  onClose?: () => void;
}

function SingleRecordAiAnalysis({
  isLoading,
  analysisResult,
  isAnalysisOutdated,
  isError,
  analysisTimestamp,
  onClose,
}: SingleRecordAiAnalysisProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex flex-row items-center gap-2">
        <OdinIcon icon="Loader" size={OdinIconSize.ExtraSmall} spin />
        {t('analysing', 'Analysing')}...
      </div>
    );
  }
  if (isError) {
    return <div>{t('ai-field-generation-error')}</div>;
  }

  return (
    <div className="relative">
      {onClose && (
        <div className="absolute right-0 top-0">
          <IconButton icon="X" onClick={onClose} />
        </div>
      )}

      {analysisResult && (
        <RecordAnalysis
          inferred_context={analysisResult.inferred_context || ''}
          data_quality_notes={analysisResult.data_quality_notes || ''}
          patterns_and_insights={analysisResult.patterns_and_insights || []}
          analysis={analysisResult.analysis || {}}
        />
      )}
      {analysisResult && analysisTimestamp && (
        <div className="text-gray-400 mb-2 flex items-center justify-between text-xs">
          <p>
            {t('generated-at', 'Generated at')} {new Date(analysisTimestamp).toLocaleTimeString()}
          </p>
          {isAnalysisOutdated && <p>{t('may-be-out-of-date', 'May be out of date')}</p>}
        </div>
      )}
    </div>
  );
}

export default SingleRecordAiAnalysis;
